import React from "react";
import DateUtils from "../../../../shared/utils/DateUtils";
import IconAction from "../../../../shared/components/generic/button/icon-action/icon-action";

export const variluxGoalsColumnsConfig = ({
    onEdit,
    onDelete
}) => [
    {
        key: "segmentation",
        label: "Tamanho do Cliente",
        width: "15%",
        render: row => row.segmentation || "-"
    },
    {
        key: "additionalPairsYear1",
        label: "Pares Adicionais Ano 1",
        width: "15%",
        render: row => row.additionalPairsYear1 || "-"
    },
    {
        key: "additionalPairsYear2",
        label: "Pares Adicionais Ano 2",
        width: "15%",
        render: row => row.additionalPairsYear2 || "-"
    },
    {
        key: "additionalPairsYear3",
        label: "Pares Adicionais Ano 3",
        width: "15%",
        render: row => row.additionalPairsYear3 || "-"
    },
    {
        key: "createdAt",
        label: "Data de criação",
        width: "14%",
        render: row => DateUtils.formatDateToBrazilian(row.createdAt)
    },
    {
        key: "updatedAt",
        label: "Data da Última Atualização",
        width: "14%",
        render: row => DateUtils.formatDateToBrazilian(row.updatedAt)
    },
    {
        key: "actions",
        label: "Ações",
        width: "12%",
        render: row => (
            <IconAction
                row={row}
                actions={[
                    {
                        key: "edit",
                        variant: "edit",
                        title: "Editar",
                        onClick: onEdit
                    },
                    {
                        key: "delete",
                        variant: "delete",
                        title: "Excluir",
                        onClick: onDelete
                    }
                ]}
            />
        )
    }
];